export enum QuotationResultStatusEnum {
  Expired = 'EXPIRED',
  InternallyRejected = 'INTERNALLY_REJECTED',
  Prepared = 'PREPARED',
  Rejected = 'REJECTED',
  Started = 'STARTED',
  UpdatePrepared = 'UPDATE_PREPARED',
  UpdateRejected = 'UPDATE_REJECTED',
}
